"use client";

// components
import HeroSection from "@/components/HeroSection ";
import ProductNavigationTabs from "@/components/ProductNavigationTabs";

// utils
import FerrySearchFormWrapper from "@/components/pages/ferry/searchForm";
import { cdnFerryPath } from "@/constants/cdnUrls";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";

function HeaderSection({
  isNavigation = true,
  mainTitle,
  customTitle,
  customMobileTitle,
  titleClassName = "",
  mobileTitleClassName = "",
  backgroundWrapperClassName,
  backgroundImageClassName,
  backgroundImage = null,
  wrapperClassName = "",
  contentClassName = "",
  searchFormInitialData = {},
  hasHeaderNavigation = false,
  titleContainerClassName = "",
}) {
  const t = useTranslationDetector("ferry");

  return (
    <HeroSection
      hasHeaderNavigation={hasHeaderNavigation}
      contentClassName={contentClassName}
      className={wrapperClassName}
      // className={wrapperClassName || "mt-32 md:mt-0"}
      titleClassName={titleClassName}
      mobileTitleClassName={mobileTitleClassName}
      titleContainerClassName={titleContainerClassName}
      mainTitle={mainTitle}
      title={
        customTitle || (
          <>
            {t("heroTitleLine1")}
            <br />
            {t("heroTitleLine2")}
          </>
        )
      }
      mobileTitle={customMobileTitle || t("heroMobileTitle")}
      navigationComponent={isNavigation && ProductNavigationTabs}
      searchComponent={FerrySearchFormWrapper}
      searchComponentProps={{
        ...searchFormInitialData,
        scrollToForm: true,
        searchButtonTextClassName: "inline md:hidden xl:inline",
        searchButtonTurnaIconClassName: "!inline-block md:!hidden xl:!block",
        searchButtonMagnifierIconClassName:
          "!hidden md:!inline-block xl:!hidden",
      }}
      backgroundImage={
        backgroundImage || {
          desktop: `${cdnFerryPath}ferry-section-back-bg-desktop.jpg`,
          mobile: `${cdnFerryPath}ferry-section-back-bg-mobile.png`,
        }
      }
      backgroundWrapperClassName={backgroundWrapperClassName}
      backgroundImageClassName={backgroundImageClassName}
    />
  );
}

export default HeaderSection;
